const W = 2880;

const wave = (y, amp, h) =>
  `M0 ${y} Q${h / 2} ${y - amp} ${h} ${y}` +
  Array.from({ length: W / h - 1 }, (_, i) => ` T${h * (i + 2)} ${y}`).join('');

const FILLS = [
  { y: 430, amp: 70, h: 360, color: 'rgba(37,99,235,0.10)', dur: 46 },
  { y: 540, amp: 90, h: 480, color: 'rgba(29,78,216,0.13)', dur: 64, reverse: true },
  { y: 660, amp: 60, h: 240, color: 'rgba(12,28,78,0.55)', dur: 36 },
];

const CONTOURS = Array.from({ length: 11 }, (_, i) => ({
  y: 90 + i * 72,
  amp: 26 + (i % 4) * 12,
  h: [240, 360, 480, 720][i % 4],
}));

const Layer = ({ dur, reverse, children }) => (
  <svg
    className="wave-layer"
    viewBox={`0 0 ${W} 900`}
    preserveAspectRatio="none"
    style={{ animationDuration: `${dur}s`, animationDirection: reverse ? 'reverse' : 'normal' }}
  >
    {children}
  </svg>
);

export const WavyBackground = () => (
  <div aria-hidden="true" data-testid="wavy-background" className="fixed inset-0 z-0 pointer-events-none overflow-hidden bg-[#060A17]">
    <div className="wave-glow w-[42vw] h-[42vw] -top-[10vw] -left-[8vw] bg-blue-700/25" />
    <div className="wave-glow w-[30vw] h-[30vw] top-[40%] right-[-6vw] bg-orange-600/10" style={{ animationDelay: '-9s' }} />
    <div className="wave-swell">
      <Layer dur={120}>
        {CONTOURS.map((c) => (
          <path key={c.y} d={wave(c.y, c.amp, c.h)} fill="none" stroke="rgba(96,165,250,0.09)" strokeWidth="1.4" />
        ))}
      </Layer>
    </div>
    {FILLS.map((f) => (
      <Layer key={f.y} dur={f.dur} reverse={f.reverse}>
        <path d={`${wave(f.y, f.amp, f.h)} V900 H0 Z`} fill={f.color} />
      </Layer>
    ))}
    <div className="grain" />
  </div>
);
